import React from "react";
import { toAbsoluteUrl } from "../../../services";
// import { Arced, Stat } from './GaugeMeter'
// import MultiProgress from './MultiProgress'

let CandidateFeedback = () => {
  const DUMMY_DATA = [{}];
  return (
    <div className="mx-auto 2xl:w-9/12 xl:w-9/12 lg:w-9/12 w-11/12 mt-2 rounded-md">
      <div className="comingSoon w-full px-10">
        <img
          className="w-full"
          src={toAbsoluteUrl("/media/nrp/candidate_feedback/comingsoon.png")}
          alt="coming soon"
        />
      </div>
    </div>

    // <div className="mx-auto 2xl:w-9/12 xl:w-9/12 lg:w-9/12 w-11/12 mt-2 shadow-lg rounded-md">
    //   <div className="bg-white rounded-md shadow-lg  py-8 w-full">
    //     <img
    //       className=""
          // src={toAbsoluteUrl("/media/candidate_feedback/comingsoon.png")}
    //       alt=""
    //     />
    //   </div>
    //   {/* <div className="questionContainer m-4">
    //                 <div className="question font-bold text-sm">Q: Lorem ipsum dolor sit amet consectetur.</div>
    //                 <div className="progressAndMeterContainer flex justify-between items-center">
    //                     <MultiProgress />
    //                     <Arced value={2} />

    //                     <div />
    //                 </div>
    //             </div>

    //             <div className="questionContainer m-4">
    //                 <div className="question font-bold text-sm">Q: Lorem ipsum dolor sit amet consectetur.</div>
    //                 <div className="progressAndMeterContainer flex justify-between items-center">
    //                     <MultiProgress />
    //                     <Arced value={2} />

    //                     <div />
    //                 </div>
    //             </div>

    //             <div className="questionContainer m-4">
    //                 <div className="question font-bold text-sm">Q: Lorem ipsum dolor sit amet consectetur.</div>
    //                 <div className="progressAndMeterContainer flex justify-between items-center">
    //                     <MultiProgress />
    //                     <Arced value={2} />

    //                     <div />
    //                 </div>
    //             </div>

    //             <div className="questionContainer m-4">
    //                 <div className="question font-bold text-sm">Q: Lorem ipsum dolor sit amet consectetur.</div>
    //                 <div className="progressAndMeterContainer flex justify-between items-center">
    //                     <MultiProgress percentProps />
    //                     <Arced value={2} />

    //                     <div />
    //                 </div>
    //             </div> */}
    //   {/* </div> */}
    // </div>
  );
};

export default CandidateFeedback;
